module.exports = __webpack_public_path__ + "media/images/flags/4x3/chn-ddc8c3f6b5e7157511f839296fb21caa.svg";